import React from 'react';
import { Provider } from 'react-redux';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { store } from './store/store';
import Home from './pages/Home';
import './App.css';

const App = () => (
  <Provider store={store}>
    <Router>
      <Routes>
        <Route path="/Filman_React" element={<Home />} />
        {/* Add other routes here */}
      </Routes>
    </Router>
  </Provider>
);

export default App;

